import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formatAmountCurrency } from '../../../../utils/index';
import SvgComponent from '../../../SvgComponent';
import { STATIC_ROOT } from '../../../../constants';

class CashbackByStatusComponent extends Component {
    render() {
        const { cssClass, amount, txt, svg } = this.props;

        return (
            <div className={`${cssClass} bloc align`}>
                <SvgComponent
                    src={`${STATIC_ROOT}/${svg}.svg`}
                    width="130"
                    height="130"
                    aria-hidden="true"
                    focusable="false"
                />
                <span className={`${cssClass} success waiting`}>
                    {formatAmountCurrency(amount)}
                </span>
                <span>{txt}</span>
            </div>
        );
    }
}

CashbackByStatusComponent.propTypes = {
    cssClass: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT
    };
}

export default connect(mapStateToProps)(CashbackByStatusComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/CashbackByStatusComponent.js